import { updateEssay } from "@/api";

export default {
  methods: {
    /**
     * Updates stickers for an essay
     * @param {Array} updatedStickers - Array of stickers to set for the essay
     * @returns {Promise<Object>} The updated essay data
     */
    async updateStickers(updatedStickers) {
      try {
        // Use essay.id for compatibility with both formats (id and essayId)
        const essayId = this.essay.id || this.essay.essayId;
        if (!essayId) {
          console.error("Essay ID is missing or invalid");
          return null;
        }

        const { data } = await updateEssay(essayId, {
          stickers: updatedStickers,
        });

        // Update the local essay object
        if (this.essay && data) {
          this.essay.stickers = data.stickers;
        }

        return data;
      } catch (error) {
        console.error("Error updating stickers:", error);
        return null;
      }
    },

    /**
     * Adds a new sticker to the essay
     * @param {Object} sticker - The sticker data to add
     * @returns {Promise<Object>} The updated essay data
     */
    async addSticker(sticker) {
      const updatedStickers = this.essay.stickers || [];
      updatedStickers.push(sticker);
      return this.updateStickers(updatedStickers);
    },

    /**
     * Removes a sticker from the essay
     * Can remove by index or by object reference
     * @param {Number|Object} stickerOrIndex - The sticker to remove or its index
     * @returns {Promise<Object>} The updated essay data
     */
    async removeSticker(stickerOrIndex) {
      if (!this.essay.stickers || !this.essay.stickers.length) {
        console.error("No stickers available");
        return null;
      }

      let updatedStickers;

      // If parameter is a number, treat as index
      if (typeof stickerOrIndex === "number") {
        const index = stickerOrIndex;
        if (index < 0 || index >= this.essay.stickers.length) {
          console.error("Invalid sticker index");
          return null;
        }
        updatedStickers = [...this.essay.stickers];
        updatedStickers.splice(index, 1);
      }
      // Otherwise treat as sticker object reference
      else {
        updatedStickers = this.essay.stickers.filter(
          (item) => item !== stickerOrIndex
        );
      }

      return this.updateStickers(updatedStickers);
    },
  },
};
